<template>
  <div class="text-left">
    <top-nav>
      <template slot="application-name">
        <nav-app-name />
      </template>

      <!-- <template slot="toggle-button">
        <nav-toggle-button />
      </template>
      -->
      <!-- <template slot="navbar-search" v-if="authPos.id != 5 ">
        <nav-search-bar :show="showSearchInput"/>
      </template> -->

      <template slot="navbar-free-slot">
        <div class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0"></div>
      </template>

      <template slot="navbar-menu-right">
        <nav-left-menu/>
      </template>

    </top-nav>

    <side-nav>
      <template slot="nav">
        <side-nav-sub></side-nav-sub>
      </template>

      <template slot="content">
        <side-nav-content></side-nav-content>
      </template>
    </side-nav>
  </div>
</template>

<script>

import SideNav from '../components/applayout/sidenav/SideNav';
import SideNavSub from '../components/applayout/sidenav/_sub/Nav';
import SideNavContent from '../components/applayout/sidenav/_sub/Content';
import TopNav from '../components/applayout/topnav/TopNav';
import NavBarLeftMenu from '../components/applayout/topnav/_sub/NavBarLeftMenu';
import NavToggleButton from '../components/applayout/topnav/_sub/NavToggleButton';
import NavSearchBar from '../components/applayout/topnav/_sub/NavSearchBar';
import NavAppName from '../components/applayout/topnav/_sub/NavAppName';
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '../mixins/app.mixins';

export default {
  name: 'Main',
  components: {
    'side-nav': SideNav,
    'side-nav-sub': SideNavSub,
    'side-nav-content': SideNavContent,
    'top-nav': TopNav,
    'nav-app-name': NavAppName,
    'nav-left-menu': NavBarLeftMenu,
    'nav-toggle-button': NavToggleButton,
    'nav-search-bar': NavSearchBar,
  },

  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
      logOutTimer: null,
      warningTimer: null,
      warningZone: false,

      showSearchInput : true,
    };
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'logOut',
        ],
    ),

    thisLogOut() {
      this.autoCloseTimerFormAlert(`This will automatically close`, 5, `Session Expired`);
      this.$nextTick(() => {
        this.logOut().then((r) => {
          if (r) {
            this.$router.push({name: 'Login'});
            location.reload();
          }
        });
      });
    },

    setTimer() {
      this.warningTimer = setInterval(this.warningMessage, 50 * 60 * 1000); //19 * 60 * 1000 for mins
      this.logOutTimer = setInterval(this.thisLogOut, 60 * 60 * 1000); //20 * 60 * 1000
      this.warningZone = false;
    },

    resetTimer() {
      clearTimeout(this.warningTimer);
      clearTimeout(this.logOutTimer);
      this.setTimer();
    },

    setShowInput(__val){
      this.showSearchInput = __val;
    },

    async warningMessage() {
      this.warningZone = true;
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'authPos',
        ],
    ),
  },

  /** mounted **/
  mounted() {
    this.events.forEach((event) => {
      window.addEventListener(event, this.resetTimer);
    }, this);

    this.setTimer();
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {
    '$route.name' :{
      handler: function(name){
        if(this.isTON()){
         this.setShowInput(false)
        }else {
          this.setShowInput(true)
        }
      },
      deep : true,
      immediate : true,
    }
  },

  /** destroyed **/
  destroyed() {
    this.events.forEach((event) => {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.resetTimer();
  },
};
</script>

<style scoped>

</style>
